export default "__VITE_ASSET__BEoFCwbt__"